import { LESS_512_MEDIA_QUERY } from '../../../../consts/adaptive';

const font = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontStyle: 'normal',
};

export const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    rightSide: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '10px',
        width: '100%',
    },
    withoutRating: {
        opacity: 0.5,
    },
    textContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    category: {
        margin: 0,
        ...font,
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '120%',
        letterSpacing: '0.035em',
        textTransform: 'uppercase',
        color: '#313140',
    },
    reviewCount: {
        margin: 0,
        fontWeight: 800,
        ...font,
        fontSize: '14px',
        color: '#9B9B9B',
        textAlign: 'right',
    },
    [LESS_512_MEDIA_QUERY]: {
        category: {
            fontSize: '9px',
        },
        reviewCount: {
            fontSize: '12px',
        },
        rightSide: {
            marginLeft: 0,
            zIndex: 2,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
